import React from "react";
import { Link } from "react-router-dom";

export default function AllservicePlansBox({
  planid,
  planimage,
  title,
  planslug,
  selling_price,
  price,
  service_tag,
}) {
  // const serviceTag = service_tag.split(",");
  // console.log(serviceTag);
  return (
    <>
      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
        <div className={` pricing-card deshboardPlanBox`}>
          <div className="pricing-card-img-box">
            <img
              className="w-100 h-100"
              src={planimage ? planimage : "images/index-12/news/4.png"}
              alt="no in this"
            />
          </div>
          <div className="pricelinkdeails">
            <h4 className="mb-0">
              <Link to={`/plans/${planslug}`}>{title}</Link>
            </h4>
            <div className="price">
              <Link to={`/plans/${planslug}`}>
                {" "}
                ₹{selling_price}
                <span className="fs-6">
                  <del> ₹{price}</del>
                </span>
              </Link>{" "}
            </div>
            <div className="purchbtn">
              <Link to={`/plans/${planslug}`} className="">
                View Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
